import React from 'react';
const PatientIcon = 'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/patient.svg';
const ArrowRightIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/arrow-right.svg';
const searchIconBlue =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/searchIconBlue.svg';
const stethoscopeIcon =
  'https://agendamento-images-nprd.telemedicinaeinstein.com.br/schedule-lib-assets/estetoscopio.svg';

import * as S from './styles';

type SearchResultProps = {
  icon?: string;
  title: string;
  subtitle?: string;
  type: string;
  onClick: () => void;
};

export const SearchResult: React.FC<SearchResultProps> = ({ subtitle, icon, title, type, onClick }) => {
  const getIcon = (icon: string): any => {
    return `https://agendamento-images-nprd.telemedicinaeinstein.com.br/icons/${icon}`;
  };

  return (
    <S.Container onClick={onClick}>
      {type === 'SPECIALIST' && <img className="icon" src={icon || PatientIcon} alt="specialist" />}
      {type === 'PRODUCT' && <img className="icon" src={(icon && getIcon(icon)) || stethoscopeIcon} alt="product" />}
      {type === 'SPECIALTY' && <img className="icon" src={stethoscopeIcon} alt="specialty" />}
      {type === 'SERVICE' && <img className="icon" src={(icon && getIcon(icon)) || stethoscopeIcon} alt="service" />}
      <S.InfoWrapper>
        <p className="title">{title}</p>
        <p className="subtitle">{subtitle}</p>
      </S.InfoWrapper>
      {type === 'SPECIALTY' ? (
        <img className="icon" src={searchIconBlue} alt="specialty" />
      ) : (
        <img src={ArrowRightIcon} alt="" />
      )}
    </S.Container>
  );
};
